import { FC } from 'react';

import { motion } from 'framer-motion';

export type SlideProps = FC<{
  offset: number;
}>;

export const Slide: SlideProps = ({ children, offset }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: offset }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ type: 'just' }}
    >
      {children}
    </motion.div>
  );
};
